// src/components/SupportFab.tsx
import * as React from "react";
import { Fab, Tooltip, Zoom } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

type ChatFabProps = {
  onClick?: () => void;
  label?: string;
  bottom?: number;
  right?: number;
};

export default function SupportFab({
  onClick,
  label = "Support",
  bottom = 24,
  right = 24,
}: ChatFabProps) {
  return (
    <Tooltip title={label} placement="left" arrow TransitionComponent={Zoom}>
      <Fab
        size="medium"
        aria-label="open support"
        onClick={onClick}
        sx={{
          position: "fixed",
          bottom,
          right,
          backgroundColor: "#000",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 2,
          borderRadius: "999px",
          boxShadow: 6,
          "&:hover": { backgroundColor: "#222" },
          "@media (max-width:600px)": { bottom: 16, right: 16 },
        }}
      >
        <SupportAgentIcon />
      </Fab>
    </Tooltip>
  );
}